import React from "react";

export const Divider = () => (
  <div className="px-4">
    <hr/>
  </div>
)